import React, { useState, useEffect, useRef } from 'react';
import { useNavigate, useParams, useLocation } from 'react-router-dom';
import Helper from '../Helper';
import Navbar from './sub/navbar';
import JobDetail from './sub/JobDetail';
import moment from 'moment';
import Alert from './sub/dialog'
import { MDBContainer, MDBInputGroup, MDBSelect, MDBCard, MDBCardBody, MDBInput, MDBBtn, MDBTypography, MDBSpinner, MDBTextArea } from 'mdb-react-ui-kit';

const customerProfile = () => {
  const navigate = useNavigate();

  const [customer, setcustomer] = useState({
    name: '',
    name_en: '',
    address: '',
    phone: '',
    email: '',
    website: '',
    taxid: '',
    isdriver: 0,
    name_alt: '',
    driverid: null

  });
  const [jobNames, setJobNames] = useState([]);
  const [newJobName, setNewJobName] = useState('');

  const addJobName = () => {
    if (newJobName.trim() !== '') {
      setJobNames([...jobNames, { text: newJobName.trim() }]);
      setNewJobName('');
    }
  };

  const removeJobName = (index) => {
    setJobNames(jobNames.filter((_, i) => i !== index));
  };

  const editJobName = (index, newName) => {
    const updatedJobNames = [...jobNames];
    updatedJobNames[index].text = newName;
    setJobNames(updatedJobNames);
  };

  let { name } = useParams();


  const [drivers, setDrivers] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');
  const alert = useRef();
  const setError = (message, ismessage) => (ismessage ? alert.current.showmessage(message) : alert.current.showerror(message));


  const fetchDrivers = async () => {
    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/getitem/driver`, {
        method: 'GET',
        headers: {
          'Authorization': `Bearer ${Helper.gettoken()}`,
          'Content-Type': 'application/json',
        },
      });
      const data = await response.json();
      if (response.ok) {
        setDrivers(data.result);
      } else {
        setError(data.message || 'Failed to fetch master list');
      }
    } catch (err) {
      setError('An error occurred while fetching the master list.');
    }
  };

  // Fetch customer profile
  useEffect(() => {
    if (!Helper.gettoken()) {
      navigate('/login');
      return;
    }

    if (!["admin"].includes(Helper.getuserrole())) {
      navigate('/main');
      return;
    }
    fetchDrivers();
    if (name)
      fetchcustomer(name);
  }, []);

  const fetchcustomer = async (name) => {
    try {

      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/GetcustomerProfile/${name}`, {
        headers: { 'Authorization': `Bearer ${Helper.gettoken()}`, }
      });
      const data = await response.json();
      if (data && data.customer) {
        setcustomer(data.customer);
        setJobNames(data.jobnames || []);

      }
    } catch (error) {
      setError('Error fetching customer profile');
    }
  };

  // Handle input changes
  const handleChange = (e) => {
    setcustomer({ ...customer, [e.target.name]: e.target.value });
  };



  // Save customer profile
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');

    try {
      const token = sessionStorage.getItem('authToken');
      const response = await fetch(`${process.env.REACT_APP_API_URL}/api/SavecustomerProfile`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'Authorization': `Bearer ${Helper.gettoken()}`
        },
        body: JSON.stringify({ customer, jobNames })
      });

      const data = await response.json();
      if (!response.ok) {
        setError(data.message || 'Failed to update profile');
      }
      else if (data && data.customer) {
        setcustomer(data.customer);
        setJobNames(data.jobNames || []);
        setError("บันทึกข้อมูลเรียบร้อยแล้ว", true);

      }

    } catch (error) {
      console.error('Error updating customer profile:', error);
      setError('Failed to update profile');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <Navbar />
      <MDBContainer fluid className="my-3">
        <Alert ref={alert} />
        <MDBCard >
          <MDBCardBody>
            <MDBTypography tag="h4" className=" mb-4">
              ข้อมูลลูกค้า
            </MDBTypography>
            {message && <p className="text-center text-success">{message}</p>}
            <form onSubmit={handleSubmit}>
              <MDBInput
                label="รหัสลูกค้า"
                name="customer_id"
                value={customer.customer_id}
                readOnly
                required
                className="mb-3"
              />
              <MDBInput
                label="ชื่อบริษัท"
                name="name"
                value={customer.name}
                onChange={handleChange}
                required
                className="mb-3"
              />
              <MDBTextArea
                label="ที่อยู่"
                name="address"
                value={customer.address ?? ""}
                onChange={handleChange}
                className="mb-3"
                rows={4}
              />
              <MDBInput
                label="เบอร์โทร"
                name="phone"
                value={customer.phone}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBInput
                label="Email"
                type="email"
                name="email"
                value={customer.email}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBInput
                label="เลขที่ภาษี"
                type="text"
                name="tax"
                value={customer.tax}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBInput
                label="สาขา"
                type="text"
                name="branch"
                defaultValue="สาขาใหญ่"
                value={customer.branch}
                onChange={handleChange}
                className="mb-3"
              />
              <MDBInput
                label="ชื่อเรียก"
                type="text"
                name="name_alt"
                value={customer.name_alt}
                onChange={handleChange}
                className="mb-3"
              />
              <div className="form-check mb-3">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="isdriverCheck"
                  checked={!!customer.isdriver}
                  onChange={(e) => setcustomer({ ...customer, isdriver: e.target.checked ? 1 : 0, driverid: e.target.checked ? customer.driverid : null })}
                />
                <label className="form-check-label" htmlFor="isdriverCheck">
                  เป็นคนรถ
                </label>
              </div>
              {!!customer.isdriver && (
                <MDBSelect
                  style={{ width: "500px" }}
                  label="คนรถ"
                  search
                  className="mb-3"
                  data={[
                    { text: '-- เลือกคนขับรถ --', value: 0 },
                    ...drivers.map((d) => ({
                      text: d.text,
                      value: d.value
                    }))
                  ]}
                  value={customer.driverid}
                  onChange={(e) => {
                    if (!e || e.value === 0) return;
                    setcustomer({...customer, name_alt: e.text ,driverid:e.value});
                  }}

                />
              )}

              <div className="job-names-section col-md-4 mb-3">
                <h5>งาน</h5>
                <ul className="list-group mb-3">
                  {jobNames.map((job, index) => (

                    <MDBInputGroup key={index} className='mb-2' >
                      <MDBInput
                        value={job.text}
                        onChange={(e) => editJobName(index, e.target.value)}
                        className="me-2"
                      />
                      <MDBBtn color="danger" onClick={() => removeJobName(index)} style={{ whiteSpace: 'nowrap' }}>
                        ลบ
                      </MDBBtn>
                    </MDBInputGroup>

                  ))}
                </ul>
                <div className="d-flex align-items-center">
                  <MDBInputGroup className='mb-3'>
                    <MDBInput
                      className='form-control me-2'
                      label="ชื่องาน"
                      value={newJobName}
                      onChange={(e) => setNewJobName(e.target.value)}
                    />
                    <MDBBtn type='button' color="primary" outline onClick={addJobName} style={{ whiteSpace: 'nowrap' }}>
                      เพิ่มงาน
                    </MDBBtn>
                  </MDBInputGroup>
                </div>
              </div>
              <div className="text-center">
                <MDBBtn type="submit" disabled={loading}>
                  {loading ? <MDBSpinner size="sm" role="status" tag="span" /> : 'บันทึก'}
                </MDBBtn>
              </div>
            </form>
          </MDBCardBody>
        </MDBCard>
      </MDBContainer>
    </>
  );
};

export default customerProfile;
